export default __webpack_public_path__ + "static/media/alert-white.7b8442e9.svg";